/***      徽章        ***/
<template>
  <div class="badgeMod">
    {{text}}
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    components: {},
    props: ['text'],
    name: 'xk-badgeMod',
    computed: {
      ...mapGetters({})
    },
    data () {
      return {}
    },
    watch: {},
    methods: {},
    mounted: function () {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .badgeMod {
    min-width: 1.1rem;
    height: 1.1rem;
    border-radius: 1rem;
    background: #F9554D;
    color: #fff;
    text-align: center;
    font-size: 0.88rem;
    padding: 0.1rem;
    line-height: 1.5;
  }
</style>



// WEBPACK FOOTER //
// badge.vue?b29dfa02